import React from "react";
import { Link } from "react-router-dom";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function NotFoundPage() {
  const { ui } = useOrignalUi();
  return (
    <main className="og-page" data-testid="page-404">
      <h1>404</h1>
      <p>{ui.errors.notFound}</p>
      <Link className="og-btn og-btn--primary" to="/">{ui.nav.today}</Link>
    </main>
  );
}
